import classnames from 'classnames';
import { bool, func, string } from 'prop-types';
import React from 'react';
import { GoLinkExternal } from 'react-icons/go';
import { Label } from 'reactstrap';

import ExpandButton from '../../../generic/ExpandButton';

export default function CampaignLineHeaderActions({
  label,
  selected,
  disableSelection,
  onToggleSelection,
  expanded,
  onToggleExpansion,
  isProduct,
  externalLink,
}) {
  const labelClasses = classnames('mb-0 ml-2', {
    h4: !isProduct,
    h5: isProduct,
  });

  return (
    <div className="d-flex align-items-center">
      <input
        type="checkbox"
        checked={selected}
        className="mr-2"
        disabled={disableSelection}
        id={`headerLineCheck-${label}`}
        onChange={onToggleSelection}
      />
      <ExpandButton expanded={expanded} onClick={onToggleExpansion} />
      <Label for={`headerLineCheck-${label}`} className={labelClasses}>
        {label}
        {externalLink ? (
          <a
            href={externalLink}
            className="ml-2"
            target="_blank"
            rel="noreferrer"
          >
            <GoLinkExternal />
          </a>
        ) : null}
      </Label>
    </div>
  );
}

CampaignLineHeaderActions.propTypes = {
  label: string.isRequired,
  selected: bool.isRequired,
  disableSelection: bool.isRequired,
  onToggleSelection: func.isRequired,
  expanded: bool.isRequired,
  onToggleExpansion: func.isRequired,
  isProduct: bool,
  externalLink: string,
};

CampaignLineHeaderActions.defaultProps = {
  isProduct: false,
  externalLink: '',
};
